import gql from 'graphql-tag';

import { CountryFragments } from './fragments/CountryType';
import { FishingWaterFragments } from './fragments/FishingWaterType';
import { PlaceFragments } from './fragments/PlaceType';
import { RegionFragments } from './fragments/RegionType';

export const getRegion = gql`
  query GetRegion($id: String!) {
    entry: region(id: $id) {
      ...RegionId
      localName
      country {
        ...CountryId
        countryName
      }
      topFishingWaters(first: 12) {
        edges {
          node {
            ...FishingWaterCarouselItem
          }
        }
      }
      places(first: 12) {
        edges {
          node {
            ...PlaceCarouselItem
          }
        }
      }
    }
  }
  ${CountryFragments.id}
  ${FishingWaterFragments.carouselItem}
  ${PlaceFragments.carouselItem}
  ${RegionFragments.id}
`;

export const getWatersInRegionBySpecies = gql`
  query GetWatersInRegionBySpecies($id: String!, $speciesId: String) {
    entry: region(id: $id) {
      ...RegionId
      topFishingWaters(first: 12, speciesExternalId: $speciesId) {
        edges {
          node {
            ...FishingWaterId
            displayName
            catchesCount
          }
        }
      }
    }
  }
  ${FishingWaterFragments.id}
  ${RegionFragments.id}
`;

export const getRegionName = gql`
  query GetRegionName($id: String!) {
    region(id: $id) {
      ...RegionId
      name
      country {
        ...CountryId
        countryName
      }
    }
  }
  ${CountryFragments.id}
  ${RegionFragments.id}
`;
